import type { ReactNode } from 'react';
import { EmployeeExportFormat, PerformanceReviewExportType } from '@/common/graphql';

export const EXPORT_REQUEST_SENT_MESSAGE =
  'Export request has been sent. You will be notified by email, or check Export History for progress.';

export const EMPLOYEE_EXPORT_FORMAT_LABELS: Record<EmployeeExportFormat, ReactNode> = {
  [EmployeeExportFormat.CreateTemplate]: (
    <>
      Import Template
      <br />
      (Create Employee)
    </>
  ),
  [EmployeeExportFormat.GeneralInformation]: 'General Information',
  [EmployeeExportFormat.PersonalInformation]: 'Personal Information',
  [EmployeeExportFormat.JobHistoryContract]: 'Job / Contract History',
  [EmployeeExportFormat.OffBoarding]: 'Off-boarding Information',
  [EmployeeExportFormat.ManagerialAccountingImportTemplate]: (
    <>
      Import Template
      <br />
      (Managerial Accounting)
    </>
  ),
};

export const PERFORMANCE_REVIEW_EXPORT_TYPE_LABELS: Record<PerformanceReviewExportType, string> = {
  [PerformanceReviewExportType.List]: 'List',
  [PerformanceReviewExportType.Results]: 'Results',
  [PerformanceReviewExportType.Details]: 'Detail (All contents)',
};
